import React, { useState } from "react";

export default function WhatsAppForm() {
  const [nome, setNome] = useState("");
  const [problema, setProblema] = useState("");

  const enviarWhatsApp = (e) => {
    e.preventDefault();
    const numeroMecanica = "5514991186107";
    const mensagem = `Olá, meu nome é ${nome}.\n\nEstou com o seguinte problema:\n\n${problema}`;
    const url = `https://wa.me/${numeroMecanica}?text=${encodeURIComponent(mensagem)}`;
    window.open(url, "_blank");
  };

  return (
    <section id="contato" className="py-12 px-6 text-center">
      <h3 className="text-2xl font-bold mb-6">Faça seu orçamento</h3>
      <form onSubmit={enviarWhatsApp} className="max-w-md mx-auto bg-white p-6 rounded-lg shadow space-y-4">
        <input type="text" placeholder="Seu nome" className="w-full border p-2 rounded" value={nome} onChange={(e) => setNome(e.target.value)} required />
        <textarea placeholder="Descreva o problema do carro" className="w-full border p-2 rounded" rows="4" value={problema} onChange={(e) => setProblema(e.target.value)} required></textarea>
        <button type="submit" className="w-full bg-green-500 text-white p-3 rounded-lg font-bold hover:bg-green-600">
          Enviar pelo WhatsApp
        </button>
      </form>
    </section>
  );
}
